import React from 'react'
import { BottomTabNavigationProp, createBottomTabNavigator } from '@react-navigation/bottom-tabs'
import { CompositeNavigationProp, RouteProp, useTheme } from '@react-navigation/native'
import { NativeStackNavigationProp } from '@react-navigation/native-stack'
import { Messages, Notifications, Chatbot } from '@screens'
import { useLanguage } from '@context'
import { Icon } from '@components'
import { TabBar } from './TabBar'
import { RootStackParamList } from '../navigationTypes'
import { MenuNavigator } from './MenuNavigator'
import { ListingContacts } from '@screens'

export type TabScreenProps<RouteName extends keyof RootTabParamList> = {
  navigation: CompositeNavigationProp<
    BottomTabNavigationProp<RootTabParamList, RouteName>,
    NativeStackNavigationProp<RootStackParamList>
  >
  route: RouteProp<RootTabParamList, RouteName>
}

export type RootTabParamList = {
  Home: undefined
  ListContacts: undefined
  ListMessages: undefined
  Notifications: undefined
  Chatbot: undefined
  MenuNavigator: undefined
}

const Tab = createBottomTabNavigator<RootTabParamList>()

export const TabNavigator = () => {
  const { colors } = useTheme()
  const { t } = useLanguage()

  const initialRoute = 'ListContacts'

  return (
    <Tab.Navigator
      tabBar={(props) => <TabBar {...props} />}
      initialRouteName={initialRoute}
      screenOptions={{
        headerShown: false,
        tabBarStyle: {
          backgroundColor: colors.background,
        },
      }}
    >
      <Tab.Screen
        name="ListContacts"
        component={ListingContacts}
        options={{
          title: t('tabNavigation.contacts'),
          tabBarIcon: ({ color, size }) => <Icon name="people" size={size} color={color} />,
        }}
      />

      <Tab.Screen
        name="ListMessages"
        component={Messages}
        options={{
          title: t('tabNavigation.messages'),
          tabBarIcon: ({ color, size }) => <Icon name="messageCircle" size={size} color={color} />,
        }}
      />

      <Tab.Screen
        name="Notifications"
        component={Notifications}
        options={{
          title: t('tabNavigation.notifications'),
          tabBarIcon: ({ color, size }) => <Icon name="bell" size={size} color={color} />,
        }}
      />
      <Tab.Screen
        name="Chatbot"
        component={Chatbot}
        options={{
          title: t('tabNavigation.chatbot'),
          tabBarIcon: ({ color, size }) => <Icon name="star" size={size} color={color} />,
          tabBarHideOnKeyboard: true,
        }}
      />
      <Tab.Screen
        name="MenuNavigator"
        component={MenuNavigator}
        options={{
          title: t('tabNavigation.profile'),
          tabBarIcon: ({ color, size }) => <Icon name="menu" size={size} color={color} />,
        }}
      />
    </Tab.Navigator>
  )
}
